import { gql } from '@apollo/client';

const VIDEO_REVIEW_FIELDS = gql`
  fragment VideoReviewFields on VideoReview {
    id
    digest
    camera
    room
    recordedAt
    people {
      segments {
        action
        startMs
        endMs
        reason
      }
      durationMs
      pastWords
      rounds
      canGiveWords
    }
    maxRevisions
    limits {
      maxNoteChars
      maxNoteAudioSeconds
    }
  }
`;

export const LIST_MY_TASKS_QUERY = gql`
  query ListMyTasks($kitchen: Kitchen!, $from: AWSDateTime!, $to: AWSDateTime!) {
    listMyTasks(kitchen: $kitchen, from: $from, to: $to) {
      id
      kind
      title
      startsAt
      endsAt
      doneAt
      productionPlan {
        taskId
        type
        locationId
        itemType
        itemId
        itemName
        quantity
        unit
        readyBy
        rationale
      }
      videoReview {
        jobId
        camera
        room
        peopleCount
        newAnswerFromYourNotes
      }
    }
  }
`;

export const COMPLETE_TASK_MUTATION = gql`
  mutation CompleteTask($kitchen: Kitchen!, $id: ID!) {
    completeTask(kitchen: $kitchen, id: $id) {
      id
      doneAt
    }
  }
`;

export const GET_TODAY_PROGRESS_QUERY = gql`
  query GetTodayProgress($kitchen: Kitchen!) {
    getTodayProgress(kitchen: $kitchen) {
      done
      goal
      kitchenChecked
    }
  }
`;

export const GET_VIDEO_REVIEW_QUERY = gql`
  ${VIDEO_REVIEW_FIELDS}
  query GetVideoReview($id: ID!) {
    getVideoReview(id: $id) {
      ...VideoReviewFields
    }
  }
`;

export const GET_VIDEO_REVIEW_CLIP_URL_QUERY = gql`
  query GetVideoReviewClipUrl($id: ID!) {
    getVideoReviewClipUrl(id: $id) {
      url
      expiresInSeconds
      fps
      frameWidth
      frameHeight
      people {
        firstFrame
        lastFrame
        boxes {
          frame
          x1
          y1
          x2
          y2
        }
      }
    }
  }
`;

export const SUBMIT_VIDEO_REVIEW_MUTATION = gql`
  mutation SubmitVideoReview($input: SubmitVideoReviewInput!) {
    submitVideoReview(input: $input)
  }
`;

export const SKIP_VIDEO_REVIEW_MUTATION = gql`
  mutation SkipVideoReview($id: ID!, $reason: VideoReviewSkipReason, $spentMs: Int, $clientVersion: Int) {
    skipVideoReview(id: $id, reason: $reason, spentMs: $spentMs, clientVersion: $clientVersion)
  }
`;

export const RECORD_VIDEO_REVIEW_EVENT_MUTATION = gql`
  mutation RecordVideoReviewEvent($input: VideoReviewEventInput!) {
    recordVideoReviewEvent(input: $input)
  }
`;

export const TRANSCRIBE_VIDEO_REVIEW_WORDS_MUTATION = gql`
  mutation TranscribeVideoReviewWords($audio: VideoReviewAudioInput!) {
    transcribeVideoReviewWords(audio: $audio) {
      text
    }
  }
`;
